import {Fragment, useEffect, useState} from "react";
import {BreadCrumb, TablePaging, CenteredModal, FormInput} from "~/components";
import UserRoleAPI from '~/api/userRoleApi';
import {useForm} from "react-hook-form";
const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "User Role", to: "", isActive: true },
]
function UserRole(){
    const tablePagingConfig = {
        columns: [
            {
                name: 'USERNAME',
                width: '200px',
                className: 'fw-bold',
                key: 'UserName',
                template: (row) => {
                    return (
                        <div className=" d-flex align-items-center text-body" data-discover="true">
                            <div className="avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={row.AvatarUrl}/>
                            </div>
                            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.UserName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'EMAIL',
                width: '200px',
                key: 'Email'
            },
            {
                name: 'ROLES',
                width: '200px',
                key: 'Roles',
                template: (row) => {
                    const roles = JSON.parse(row.Roles);
                    return (
                        <ul className="ps-3 mb-0">
                            {
                                roles.map((item, index)  => (
                                        <li key={index}>{item.Name}</li>
                                    ))
                            }
                        </ul>
                    )
                }
            },
            {
                name: 'ASSIGN ROLE',
                width: '70px',
                key: 'AssignRole',
                headerClassName: "text-center",
                className: 'text-center',
                template: (row) => {
                    return (
                        <button type= "button" onClick={() => handleAssignRole(row.UserId)} className="btn btn-bt-primary">Assign Role</button>
                    )
                }
            }
        ],
        url: "/user-roles/paged",
        tableKey: "TableUserRole"
    }

    const [showModal, setShowModal] = useState(false);
    const [roleData, setRoleData] = useState({});
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [reloadTable, setReloadTable] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        reset ,
        formState: { errors }
    } = useForm({
        defaultValues: {
            Roles: roleData.Roles?.filter(r => r.HasRole).map(r => r.Name) || []
        }
    });

    useEffect(() => {
        if (roleData.Roles) {
            reset({
                Roles: roleData.Roles.filter(r => r.HasRole).map(r => r.Name),
                AdminPassword: ""
            });
        }
    }, [roleData, reset]);

    const handleAssignRole = (userId) => {
        setSelectedUserId(userId);
        UserRoleAPI.getRolesByUser(userId)
            .then(res => {
                setRoleData(res.data);
                setShowModal(true);
            })
            .catch(err => {})
    }

    const onSubmitFrom = (data) => {
        const selectedRoles = roleData.Roles?.map(item => ({
            Name: item.Name,
            HasRole: data.Roles?.includes(item.Name) || false
        }));
        const payload = {
            UserId: selectedUserId,
            AdminPassword: data.AdminPassword,
            Roles: selectedRoles,
            AdminId: localStorage.getItem("userId")
        };
        UserRoleAPI.assignUserRole(payload)
            .then(res => {
                if(res.data?.Succeeded){
                    setShowModal(false);
                    setReloadTable(prevState => !prevState);
                }
            })
            .catch(err => {
                if (err.response) {
                    setErrorMessage(err.response.data.Message);
                }
            })
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-3">User Role</h2>
            <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
            <CenteredModal show={showModal} title="Assign user role" formId="formAssignUserRole" onClose={() => setShowModal(false)} >
                <div className="mb-3">
                    <form onSubmit={handleSubmit(onSubmitFrom)} id="formAssignUserRole">
                        <p className="mb-0 mb-1 text-center fs-8-1"> UserName: <strong>{roleData.UserName}</strong></p>
                        <p className="mb-0 mb-1 text-center fs-8-1"> Email:  <strong>{roleData.Email} </strong></p>
                        <div>
                            {
                                roleData.Roles?.map((item, index)  => (
                                    <div className="form-check" key={index}>
                                        <input id={item.Name} className="form-check-input" type="checkbox"
                                               value={item.Name}
                                               {...register("Roles")}
                                        />
                                        <label title="" htmlFor={item.Name} className="form-check-label">
                                            {item.Name}
                                        </label>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            errorMessage &&
                            (
                                <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                                    <span className="text-danger fw-bold fs-9">{errorMessage}</span>
                                </div>
                            )
                        }
                        <div>
                            <span className="fs-8-1 fw-bold" >Enter your password to confirm</span>
                        </div>
                        <FormInput
                            label="Verify Password"
                            name="AdminPassword"
                            register={register}
                            errors={errors}
                            required={true}
                            defaultValue=""
                            messageRequired="Password is required."
                            maxLengthText = ""
                        />
                    </form>
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default UserRole;